import React from 'react';

import type { Text } from '@zillow/constellation';
import { FormField, Input, Label } from '@zillow/constellation';

import type { Section } from '../../../models';
import type { HTMLElementEvent } from '../../../models/Types';
import { ZONING } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Zoning({ section, setSectionValues }: Props) {
  function onZoningDistrictChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [ZONING.FIELD_NAME.ZONING_DISTRICT]: value,
    });
  }

  return (
    <FormField
      label={<Label size="lg">What is the Zoning District for your property?</Label>}
      control={
        <Input value={section.getFieldValue(ZONING.FIELD_NAME.ZONING_DISTRICT)} onChange={onZoningDistrictChange} />
      }
    />
  );
}

export default Zoning;
